import { getSimulatorType } from "@/lib/simulatorType"
import { SimulatorType } from "@/types/api/SimulatorType"

export const formatSimulatorType = (type: string): string => {
  const simulatorType = getSimulatorType(type)

  switch (simulatorType) {
    case SimulatorType.VOICE:
      return "Inbound Voice"
    case SimulatorType.OUTBOUND_VOICE:
      return "Outbound Voice"
    case SimulatorType.TEXT:
      return "Chat"
    case SimulatorType.CHAT_A2A:
      return "A2A Chat"
    case SimulatorType.SMS:
      return "SMS"
    case SimulatorType.WEBSOCKET:
      return "WebSocket"
    case SimulatorType.CHAT_WEBSOCKET:
      return "Chat WebSocket"
    case SimulatorType.LIVEKIT:
      return "LiveKit"
    case SimulatorType.PIPECAT:
      return "PipeCat"
    case SimulatorType.OPENAI_REALTIME:
      return "OpenAI Realtime"
    case SimulatorType.GEMINI_REALTIME:
      return "Gemini Live"
    case SimulatorType.GROK_REALTIME:
      return "Grok Realtime"
    case SimulatorType.DEEPGRAM_REALTIME:
      return "Deepgram Voice Agent"
    case SimulatorType.NOOP:
      return "No-op"
    case null:
    case SimulatorType.STT:
    case SimulatorType.REALTIME_VOICE_TO_VOICE:
    default:
      return type
        .replace("MODEL_TYPE_", "")
        .toLowerCase()
        .replace(/\b\w/g, (c: string) => c.toUpperCase())
  }
}
